import angular from 'angular';
import {Engine} from '@acng/frontend-stargazer';
import {Error, HTMLElement, removeChildNodes, getAttribute} from '@acng/frontend-bounty';

import {portal} from '../portal.js';
import {spinner} from '../service/spinner';
import {coreFeature} from '../config/feature';
import {inject, $compile} from '../service/ng.js';

const SCOPE = Symbol();

coreFeature.defineElement(
  'onsw-template',
  class extends HTMLElement {
    connectedCallback() {
      connect(this, (this[SCOPE] = inject('$rootScope').$new()));
    }

    disconnectedCallback() {
      this[SCOPE]?.$destroy();
    }
  }
);

/**
 * @param {HTMLElement} host
 * @param {angular.IScope & {portal?: typeof portal}} $scope
 */
const connect = async (host, $scope) => {
  const [feature, name] = (() => {
    if (host.dataset.feature) {
      return [host.dataset.feature, host.dataset.name];
    }
    return (getAttribute(host, 'template') ?? '').split('.');
  })();

  removeChildNodes(host);
  if (!feature || !name) {
    throw Error();
  }

  (await spinner(Engine.root.render(feature, name), host)).toElement(host);
  $scope.portal = portal;
  inject($compile)(angular.element(host).children())($scope);
  $scope.$digest();
};
